export default "__VITE_ASSET__BuU7XIZu__"